




























































































import { Vue, Component } from 'vue-property-decorator';
import { VbSnackbarService } from 'bag-of-holding-library';
import CardTitle from '@/shared/card/card-title.component.vue';
import SurveyService from '@/domain/survey/survey.service';
import Survey from '@/domain/survey/entity/survey.entity';
import SurveyType from '@/domain/survey/entity/survey-type.enum';
import TextAreaComponent from '@/views/survey/components/text-area-component.vue';
import RadioComponent from '@/views/survey/components/radio-component.vue';
import ActivityHappinessAnswer from '@/domain/activity/entity/activity-happiness-answer.entity';
import replaceVariableOnText from '@/shared/utils/replace-variable-on-text';
import ActivityScheduleService from '@/domain/schedule/activitie/activity.service';
import ActivityDTO from '@/domain/schedule/activitie/activity-dto.entity';
import Loading from '@/shared/loading/loading.component.vue';
import SuccessCardComponent from '@/views/survey/success-card.component.vue';
import LottieAnimation from 'lottie-web-vue';
import CheckAnitionJSON from '@/assets/check-animation.json';
import SelectLanguageComponent from '@/views/survey/select-language.component.vue';
import ActivityService from '@/domain/activity/service/activity.service';
import NotFoundComponent from '@/shared/not-found/not-found.component.vue';

@Component({
  components: {
    CardTitle,
    Loading,
    SuccessCardComponent,
    LottieAnimation,
    SelectLanguageComponent,
    NotFoundComponent,
  },
})
export default class ActivityHappinessView extends Vue {
  survey: Survey = new Survey();

  activityHappinessAnswers: ActivityHappinessAnswer = new ActivityHappinessAnswer();

  activity: ActivityDTO = ActivityDTO.of({});

  loading: boolean = false;

  sended: boolean = false;

  checkAnitionJSON = CheckAnitionJSON

  languages = [
    {
      text: 'Brasil - pt-br',
      acronym: 'PT_BR',
      acronymFlag: 'BRA',
    },
    {
      text: 'Espanhol - es',
      acronym: 'ES',
      acronymFlag: 'ES',
    },
    {
      text: 'English',
      acronym: 'EN',
      acronymFlag: 'US',
    },
  ]

  language: string | null = null;

  errorGetSurvey: boolean = false;

  accessError: boolean = false;

  accessErrorMessage: string = '';

  componentsModel = {
    TEXT_AREA: TextAreaComponent,
    RADIO: RadioComponent,
  }

  loadingSend: boolean = false;

  loadingSurvey: boolean = false;

  created() {
    this.loading = true;
    this.getActivity();
  }

  getActivity() {
    ActivityScheduleService.getActivityById(this.$route.params.activityId)
      .then((data) => {
        this.activity = ActivityDTO.of(data);
        this.accessError = false;
      }).catch((error) => {
        const status = error && error.response ? error.response.status : null;
        if (status === 404 || status === 403) {
          this.accessError = true;
          this.accessErrorMessage = status === 403
            ? 'Você não tem permissão para acessar esta atividade.'
            : 'Atividade não encontrada.';
        }
      }).finally(() => this.loading = false);
  }

  getSurvey() {
    if (!this.language) return;
    this.loadingSurvey = true;
    SurveyService.getSurveyByTypeAndAcronymLanguage(this.activity.surveyType, this.language)
      .then((data) => {
        this.survey = data;
        this.survey.description = replaceVariableOnText(
          this.survey.description,
          { activityName: this.activity.name },
        );
        this.activityHappinessAnswers = ActivityHappinessAnswer.createInitial(
          this.survey.template.questions,
          this.$route.params.activityId,
          this.survey.id,
        );
        this.errorGetSurvey = false;
      })
      .catch((error) => {
        this.errorGetSurvey = true;
        VbSnackbarService.handleHttpError(error);
      }).finally(() => {
        this.loadingSurvey = false;
      });
  }

  setAnswerValue(questionId: string, value: string) {
    const answerFiltered = this.activityHappinessAnswers.answers
      .filter(it => it.questionId === questionId)[0];
    answerFiltered.value = value;
  }

  get employeeFirstName() {
    const words = this.activity.employee.name.split(' ');
    return words[0];
  }

  setLanguage(acronymlanguage: string) {
    this.language = acronymlanguage;
    this.getSurvey();
  }

  get sendButtonText() {
    return this.language === 'EN' ? 'Send' : 'Enviar';
  }

  get title() {
    if (this.language === 'EN') return `Hi ${this.employeeFirstName},`;
    if (this.language === 'ES') return `Hola ${this.employeeFirstName},`;
    return `Olá ${this.employeeFirstName},`;
  }

  send() {
    this.loadingSend = true;
    ActivityService.sendActivityHappiness(this.activityHappinessAnswers)
      .then(() => {
        this.sended = true;
      }).catch((error) => {
        VbSnackbarService.handleHttpError(error);
      }).finally(() => {
        this.loadingSend = false;
      })
  }
}
